import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { CustomerListActionsCell } from './customer-list-actions.cell';
import { CustomerListActionsHeader } from './customer-list-actions.header';

export const CustomerListActionsColumn: DisplayColumnDef<
  GatewayCustomerModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: CustomerListActionsHeader,
  cell: CustomerListActionsCell,
};
